function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M423.282,324.179C423.282,324.178,423.282,324.178,423.282,324.179c-5.191-2.996-8.904-7.833-10.455-13.623 c-1.552-5.79-0.755-11.837,2.246-17.032c4.596-7.963,7.025-17.019,7.025-26.186c0-14.266-5.849-27.784-15.802-37.536 c6.693-6.508,11.534-14.721,14.013-23.976c3.624-13.529,1.764-27.66-5.236-39.791c-1.976-3.423-3.02-7.292-3.02-11.191 c0-7.998,4.299-15.452,11.222-19.46c0.004-0.002,0.008-0.005,0.012-0.007v0c0,0,0.001-0.001,0.002-0.001 c7.172-4.145,9.626-13.319,5.482-20.492c-4.144-7.172-13.317-9.628-20.491-5.483c-5.189,2.998-11.235,3.793-17.026,2.243 c-5.79-1.552-10.627-5.265-13.627-10.463c-9.349-16.177-26.761-26.226-45.443-26.226c-4.79,0-9.552,0.666-14.146,1.959 c-5.786-22.665-26.376-39.475-50.818-39.475c-5.996,0-11.632-2.334-15.861-6.563c-4.243-4.25-6.58-9.888-6.58-15.877 c0-8.284-6.716-15-15-15s-15,6.716-15,15c0,12.374-10.067,22.44-22.441,22.44c-14.009,0-27.178,5.454-37.09,15.366 c-6.759,6.77-11.445,15.056-13.737,24.087c-8.974-2.535-18.498-2.619-27.744-0.142c-13.532,3.626-24.839,12.305-31.836,24.429 c-4.005,6.931-11.465,11.236-19.468,11.236c-3.898,0-7.768-1.044-11.19-3.019c-7.174-4.14-16.346-1.682-20.488,5.49 c-4.142,7.173-1.686,16.346,5.486,20.49c0.002,0.001,0.003,0.001,0.005,0.002c0.002,0.001,0.004,0.003,0.007,0.004 c10.704,6.192,14.384,19.939,8.203,30.651c-4.604,7.976-7.037,17.03-7.037,26.186c0,14.265,5.851,27.783,15.811,37.536 c-6.693,6.507-11.535,14.721-14.015,23.974c-3.626,13.533-1.765,27.667,5.24,39.793c1.968,3.41,3.008,7.28,3.008,11.19 c0,8.013-4.298,15.471-11.217,19.463c-7.175,4.141-9.636,13.314-5.495,20.489c4.141,7.176,13.313,9.635,20.489,5.495 c0.01-0.006,0.019-0.011,0.029-0.017c10.712-6.158,24.445-2.472,30.625,8.225c9.337,16.182,26.751,26.234,45.448,26.234 c4.79,0,9.551-0.666,14.146-1.96c5.787,22.665,26.377,39.475,50.819,39.475c5.996,0,11.632,2.334,15.861,6.563 c4.243,4.25,6.58,9.889,6.58,15.878c0,8.284,6.716,15,15,15s15-6.716,15-15c0-12.374,10.067-22.441,22.44-22.441 c14.009,0,27.179-5.454,37.09-15.366c6.76-6.77,11.445-15.056,13.737-24.087c8.974,2.535,18.499,2.62,27.74,0.142 c13.526-3.625,24.834-12.302,31.845-24.438c3.992-6.919,11.45-11.217,19.463-11.217c3.91,0,7.78,1.041,11.19,3.008l0.001,0.001 c7.176,4.141,16.349,1.681,20.489-5.495C432.917,337.493,430.457,328.319,423.282,324.179z M320.995,107.975 c3.422-1.975,7.292-3.019,11.19-3.019c8.003,0,15.463,4.306,19.463,11.228c7.001,12.133,18.309,20.812,31.841,24.438 c0.168,0.045,0.336,0.089,0.504,0.133c-1.271,4.535-1.94,9.271-1.94,14.091c0,9.155,2.433,18.21,7.036,26.186 c2.997,5.193,3.793,11.243,2.242,17.034c-1.551,5.79-5.262,10.626-10.454,13.623l-7.743,4.471 c-4.026-42.705-26.772-80.045-59.931-103.693L320.995,107.975z M229.777,343.787c-62.863,0-114.006-51.143-114.006-114.006 c0-62.863,51.143-114.005,114.006-114.005c62.863,0,114.005,51.143,114.005,114.005 C343.782,292.644,292.64,343.787,229.777,343.787z M176.47,74.012c4.238-4.237,9.874-6.571,15.869-6.571 c14.642,0,27.899-6.03,37.422-15.739c0.125,0.127,0.25,0.254,0.376,0.38c9.904,9.904,23.073,15.358,37.083,15.358 c12.374,0,22.44,10.067,22.44,22.44v8.951c-18.246-8.377-38.528-13.057-59.884-13.057c-21.354,0-41.634,4.678-59.878,13.054v-8.948 C169.899,83.892,172.235,78.253,176.47,74.012z M70.471,181.031c7.316-12.679,8.72-27.179,5.072-40.28 c13.462-3.484,25.25-12.249,32.369-24.567c2.995-5.19,7.833-8.903,13.622-10.454c5.791-1.552,11.836-0.756,17.028,2.244 l7.785,4.496c-33.156,23.648-55.9,60.985-59.927,103.687l-7.741-4.47c-6.925-3.996-11.228-11.454-11.228-19.463 C67.451,188.324,68.495,184.454,70.471,181.031z M138.565,351.585c-3.422,1.975-7.292,3.019-11.19,3.019 c-8.009,0-15.467-4.302-19.467-11.234c-7.324-12.679-19.183-21.145-32.357-24.535c1.274-4.543,1.945-9.289,1.945-14.121 c0-9.167-2.43-18.223-7.028-26.191c-2.998-5.189-3.794-11.236-2.243-17.026c1.551-5.79,5.264-10.628,10.458-13.625l7.736-4.468 c4.026,42.702,26.77,80.04,59.925,103.688L138.565,351.585z M283.09,385.548c-4.237,4.237-9.873,6.571-15.869,6.571 c-14.642,0-27.899,6.03-37.422,15.739c-0.125-0.128-0.25-0.254-0.376-0.381c-9.904-9.904-23.073-15.358-37.083-15.358 c-12.374,0-22.44-10.067-22.44-22.44v-8.945c18.244,8.375,38.524,13.053,59.878,13.053c21.356,0,41.638-4.679,59.884-13.057v8.949 C289.661,375.668,287.324,381.307,283.09,385.548z M389.092,278.523c-7.007,12.131-8.869,26.265-5.243,39.798 c0.045,0.168,0.091,0.335,0.138,0.503c-13.462,3.487-25.238,12.245-32.335,24.545c-6.191,10.718-19.94,14.405-30.666,8.209 l-7.782-4.484c33.158-23.649,55.904-60.989,59.929-103.694l7.747,4.474c6.919,3.993,11.217,11.451,11.217,19.463 C392.098,271.248,391.058,275.118,389.092,278.523z"
}), React.createElement("path", {
  d: "M229.777,136.994c-51.163,0-92.788,41.624-92.788,92.787s41.625,92.788,92.788,92.788s92.787-41.625,92.787-92.788 S280.94,136.994,229.777,136.994z M229.777,292.568c-34.621,0-62.788-28.167-62.788-62.788s28.167-62.787,62.788-62.787 s62.787,28.166,62.787,62.787S264.398,292.568,229.777,292.568z"
}), React.createElement("path", {
  d: "M229.773,214.779c-3.95,0-7.81,1.6-10.6,4.4c-2.79,2.79-4.4,6.65-4.4,10.6c0,3.95,1.61,7.82,4.4,10.61s6.66,4.39,10.6,4.39 c3.95,0,7.82-1.6,10.61-4.39c2.79-2.79,4.39-6.66,4.39-10.61c0-3.95-1.6-7.81-4.39-10.6 C237.593,216.378,233.723,214.779,229.773,214.779z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgChakra = function SvgChakra(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 459.56 459.56",
    style: {
      enableBackground: "new 0 0 459.56 459.56"
    },
    xmlSpace: "preserve",
    fill: "#29507d",
    height: "100%",
    width: "100%",
    alt: "Crown Chakra by Cass Reese from the Noun Project",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChakra, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chakra.5336975d.svg";
export { ForwardRef as ReactComponent };